var React = require('react');

function Loupe (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M27.4 0.2c12.4 0.1 24 9.6 26.4 21.9 2.3 12-4.7 25.2-16 30 -12.5 5.3-28.8-0.7-34.8-13 -6.3-12.8-0.3-30.2 12.9-36.4 3.6-1.7 7.6-2.5 11.6-2.5Zm-0.3 6.2c-11.7 0.1-22.2 11.7-20.5 23.8 1.4 9.8 10.6 17.9 20.5 17.9 9.9 0.1 19.3-7.9 20.8-17.8 1.7-11.5-7.7-23.6-20.2-23.9 -0.2 0-0.4 0-0.5 0Z","key":0}),React.createElement("path",{"d":"M45 41.8c0.7 0 1.4 0.3 1.9 0.8 4.1 3.9 8 8 12 12 2.2 2.2-1.1 7.2-4.3 4.4 -4.1-3.9-8-8-12-12 -1.7-1.8-0.8-5.4 2.3-5.3Z","key":1})]);
}

Loupe.defaultProps = {"width":"60","height":"60","viewBox":"0 0 60 60","strokeLinejoin":"round"};

module.exports = Loupe;

Loupe.default = Loupe;
